module.exports = __webpack_public_path__ + "static/media/product-design-first@3x.6c659dbf.jpg";